// extracted by mini-css-extract-plugin
module.exports = {"filtersPopoverElement":"FilteredContent__filtersPopoverElement___omlRf"};